import { URL_PDF } from '../config/endpoints';

export const openPDF = async productId => {
  window.open(
    URL_PDF(productId),
    '_blank',
    'width=795, height=590, top=100, left=699, status=no, toolbar=no, menubar=no, resizable=no, fullscreen=no'
  );
};

export const findContact = (type, contacts) =>
  contacts?.find(curr => curr.tipo === type)?.valor ?? '';

export const filterContactArray = contacts =>
  contacts.filter(curr => curr.valor !== '');

export const getQueryParamValue = (query, param) =>
  query
    .split('&')
    ?.find(a => a.includes(param))
    ?.split('=')[1];

export const checkIfTrue = (condition, ifTrue, ifFalse = () => {}) => {
  ({
    true: ifTrue,
    false: ifFalse,
  }[!!condition]());
};

export const firstTitle = titles => titles.quantidade && titles.quantidade[0];
export const lastTitle = titles =>
  titles.quantidade && titles.quantidade[titles.quantidade.length - 1];
